
import { toast } from 'react-toastify';

export const toastError = (msg: any) => toast.error(msg, {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: true,
});
export const toastSuccess = (msg: any) => toast.success(msg, {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: true,
});
export const toastWarning =(msg : any) =>toast.warning(msg,{
    position: "top-center",
    autoClose: msg === 'Download in progress, Please wait for few Minutes.' ? 8000 : 3000,
    hideProgressBar: true
});